export const bulkUploadAWBErrorMessageSelector = state => state?.bulkUploadAWB?.error?.message || '';
export const bulkUploadAWBIsSubmitSelector = state => state?.bulkUploadAWB?.isSubmit || false;
export const bulkUploadAWBSuccessSelector = state => state?.bulkUploadAWB?.success?.message || '';